/* unplugin-vue-components disabled */import { render } from "./InviteRecord.vue?vue&type=template&id=26d5257f&scoped=true"
import script from "./InviteRecord.vue?vue&type=script&lang=js"
export * from "./InviteRecord.vue?vue&type=script&lang=js"

import "./InviteRecord.vue?vue&type=style&index=0&id=26d5257f&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d5257f"]])

export default __exports__